import React from 'react';
import {
  IconAirplane,
  IconCar,
  IconHotel,
  IconLounge,
  IconPoint2x,
  IconPoint3x,
  IconPoint5x,
  IconRewards, IconTravelBag,
} from '@americanexpress/dls-icons';

export const BenefitIconMap = (iconClass: string, isFilled: boolean) => {
  switch (iconClass) {
    case 'IconRewards':
      return <IconRewards size="md" isFilled={isFilled} />;
    case 'IconHotel':
      return <IconHotel size="md" isFilled={isFilled} />;
    case 'IconAirplane':
      return <IconAirplane size="md" isFilled={isFilled} />;
    case 'IconPoint2x':
      return <IconPoint2x size="md" isFilled={isFilled} />;
    case 'IconPoint3x':
      return <IconPoint3x size="md" isFilled={isFilled} />;
    case 'IconPoint5x':
      return <IconPoint5x size="md" isFilled={isFilled} />;
    case 'IconLounge':
      return <IconLounge size="md" isFilled={isFilled} />;
    case 'IconTravelBag':
      return <IconTravelBag size="md" isFilled={isFilled} />;
    case 'IconCar':
      return <IconCar size="md" isFilled={isFilled} />;
    default:
      return null;
  }
};
